import React from 'react';

interface AppStoreIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const AppStoreIcon: React.FC<AppStoreIconProps> = ({
  width = 25,
  height = 25,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.5 23.4375C18.5406 23.4375 23.4375 18.5406 23.4375 12.5C23.4375 6.45939 18.5406 1.5625 12.5 1.5625C6.45939 1.5625 1.5625 6.45939 1.5625 12.5C1.5625 18.5406 6.45939 23.4375 12.5 23.4375Z"
        fill="url(#paint0_linear_380_1661)"
      />
      <path
        d="M14.4116 6.76096C14.648 6.34833 14.5066 5.8213 14.0959 5.58381C13.6852 5.34631 13.1606 5.4883 12.9242 5.90092L12.512 6.62064L12.0996 5.90092C11.8632 5.4883 11.3386 5.34631 10.9279 5.58381C10.5172 5.8213 10.3759 6.34833 10.6123 6.76096L11.5219 8.34875L8.64469 13.371H6.32681C5.85291 13.371 5.46875 13.757 5.46875 14.233C5.46875 14.7091 5.85291 15.0951 6.32681 15.0951H14.4003C14.4711 14.9082 14.5456 14.5876 14.4663 14.2929C14.3472 13.8499 13.9063 13.371 13.1673 13.371H10.6248L14.4116 6.76096Z"
        fill="white"
      />
      <path
        d="M9.0909 16.0483C8.9445 15.8849 8.61653 15.6239 8.32887 15.538C7.89036 15.407 7.55788 15.4892 7.39014 15.5608L6.751 16.6765C6.51461 17.0891 6.65593 17.6161 7.06665 17.8536C7.47737 18.0911 8.00192 17.9491 8.23833 17.5365L9.0909 16.0483Z"
        fill="white"
      />
      <path
        d="M17.3669 15.0942H18.6733C19.1472 15.0942 19.5313 14.7083 19.5313 14.2322C19.5313 13.7561 19.1472 13.3702 18.6733 13.3702H16.3792L13.795 8.85938C13.603 9.04266 13.235 9.51086 13.1794 10.0417C13.1079 10.7241 13.2151 11.2988 13.5369 11.8616C14.6187 13.7535 15.7022 15.6446 16.7855 17.5357C17.022 17.9484 17.5465 18.0903 17.9573 17.8528C18.368 17.6153 18.5093 17.0883 18.2729 16.6757L17.3669 15.0942Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_380_1661"
          x1="12.5"
          y1="1.5625"
          x2="12.5"
          y2="23.4375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2AC9FA" />
          <stop offset="1" stopColor="#1F65EB" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AppStoreIcon;
